module.exports = __webpack_public_path__ + "img/3-12.f70978dc.png";